import { InjectionToken } from '@angular/core';
import type { FacebookConfig } from './facebook.interface';

export const FACEBOOK_CONFIG = new InjectionToken<FacebookConfig>(
  'FacebookConfig',
);
